export const GET_FIT_BIT_ACCESS_TOKEN = 'integrations/GET_FIT_BIT_ACCESS_TOKEN';
export const SET_USER_FITBIT_ACCESS_TOKEN = 'integrations/SET_USER_FITBIT_ACCESS_TOKEN';
export const REMOVE_FITBIT_ACCESS_TOKEN = 'integrations/REMOVE_FITBIT_ACCESS_TOKEN';
export const SET_USER_WITHINGS_ACCESS_TOKEN = 'integrations/SET_USER_WITHINGS_ACCESS_TOKEN';